import React from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import _ from 'lodash';

import { Heading, Text } from 'grommet';
import TableOfContentsEntry from 'app/components/BookElements/TableOfContentsEntry';

import Contents from 'app/api/contents';
import BookElement from 'app/api/bookElement';

function formatTitle(path, content, level) {
  let title = content;
  const chapterNumber = BookElement.extractChapterNumber(path);
  const hasChapterNumber = _.chain(chapterNumber)
    .parseInt()
    .isFinite()
    .value();
  if (!level && hasChapterNumber) {
    title = `Chapter ${chapterNumber}: ${title}`;
  }
  return title;
}

class Title extends React.Component {
  render() {
    const { path, content } = this.props;
    const level = Contents.extract(path, 'level');
    const getSize = level => {
      switch (level) {
        case 2:
          return 'xxlarge';
        case 3:
          return 'large';
        default:
          return 'medium';
      }
    };
    if (level) {
      return (
        <TableOfContentsEntry path={path}>
          <Text
            responsive
            size={getSize(level)}
            weight="bold"
            textAlign="center"
            margin={{ bottom: 'small' }}
            aria-label="title"
          >
            {formatTitle(path, content, level)}
          </Text>
        </TableOfContentsEntry>
      );
    }
    return (
      <TableOfContentsEntry path={path}>
        <Heading responsive textAlign="center" margin={{ bottom: 'small' }}>
          {formatTitle(path, content)}
        </Heading>
      </TableOfContentsEntry>
    );
  }
}

Title.propTypes = {
  /**
   * content path, determines numbering
   */
  path: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ).isRequired,
  /**
   * title
   */
  content: PropTypes.string,
};
Title.defaultProps = {
  content: ' ',
};

const Component = inject('AppState')(observer(Title));
Component.displayName = 'Title';
export const TitleComponent = Title;
export default Component;



// WEBPACK FOOTER //
// ./src/app/components/BookElements/Title.js